var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-spinner-wrapper"},[(!_vm.loading)?[_vm._t("default")]:_vm._e(),(_vm.loading)?_c('asc-spinner',{staticClass:"asc-spinner-wrapper--spinner",attrs:{"loading":_vm.loading}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }